// init Swiper:
const teaserSwiper = new Swiper('.field--name-field-courses', {
    loop: false,
    speed: 400,
    spaceBetween: 30,
    slidesPerView: 3,
    breakpoints: {
        320: {
            slidesPerView: 'auto'
        },
        768: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        }
    }
});

const mediaQuery = window.matchMedia('(max-width: 768px)')
if (mediaQuery.matches) {
    const blogFilterSwiper = new Swiper('.field--name-dynamic-block-fieldnode-blogs-filter .form-checkboxes .bef-checkboxes', {
        slidesPerView: 'auto',
        freeMode: true,
        createElements: true
    });
}

